import { mergeSchemas } from '@/utils/forms/form-resolver'

export function mergeJsonSchemas(baseSchema, ...others) {
  return others.reduce((mergedSchema, otherSchema) => {
    return mergeSchemas(mergedSchema, otherSchema)
  }, baseSchema)
}
